import { render, staticRenderFns } from "./Vehicle.vue?vue&type=template&id=4bb82bac&lang=pug&"
import script from "./Vehicle.vue?vue&type=script&lang=ts&"
export * from "./Vehicle.vue?vue&type=script&lang=ts&"
import style0 from "./Vehicle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports